import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { FinalDisciplinaryActionEntity } from './final-disciplinary-action.model';

export enum FinalDisciplinaryActionActionTypes {
  LoadFinalDisciplinaryActions = '[FinalDisciplinaryAction] Load FinalDisciplinaryActions',
  AddFinalDisciplinaryAction = '[FinalDisciplinaryAction] Add FinalDisciplinaryAction',
  UpsertFinalDisciplinaryAction = '[FinalDisciplinaryAction] Upsert FinalDisciplinaryAction',
  AddFinalDisciplinaryActions = '[FinalDisciplinaryAction] Add FinalDisciplinaryActions',
  UpsertFinalDisciplinaryActions = '[FinalDisciplinaryAction] Upsert FinalDisciplinaryActions',
  UpdateFinalDisciplinaryAction = '[FinalDisciplinaryAction] Update FinalDisciplinaryAction',
  UpdateFinalDisciplinaryActions = '[FinalDisciplinaryAction] Update FinalDisciplinaryActions',
  DeleteFinalDisciplinaryAction = '[FinalDisciplinaryAction] Delete FinalDisciplinaryAction',
  DeleteFinalDisciplinaryActions = '[FinalDisciplinaryAction] Delete FinalDisciplinaryActions',
  ClearFinalDisciplinaryActions = '[FinalDisciplinaryAction] Clear FinalDisciplinaryActions',
}

export class LoadFinalDisciplinaryActions implements Action {
  public readonly type = FinalDisciplinaryActionActionTypes.LoadFinalDisciplinaryActions;

  constructor(public payload: { finalDisciplinaryActions: FinalDisciplinaryActionEntity[] }) {}
}

export class AddFinalDisciplinaryAction implements Action {
  public readonly type = FinalDisciplinaryActionActionTypes.AddFinalDisciplinaryAction;

  constructor(public payload: { finalDisciplinaryAction: FinalDisciplinaryActionEntity }) {}
}

export class UpsertFinalDisciplinaryAction implements Action {
  public readonly type = FinalDisciplinaryActionActionTypes.UpsertFinalDisciplinaryAction;

  constructor(public payload: { finalDisciplinaryAction: FinalDisciplinaryActionEntity }) {}
}

export class AddFinalDisciplinaryActions implements Action {
  public readonly type = FinalDisciplinaryActionActionTypes.AddFinalDisciplinaryActions;

  constructor(public payload: { finalDisciplinaryActions: FinalDisciplinaryActionEntity[] }) {}
}

export class UpsertFinalDisciplinaryActions implements Action {
  public readonly type = FinalDisciplinaryActionActionTypes.UpsertFinalDisciplinaryActions;

  constructor(public payload: { finalDisciplinaryActions: FinalDisciplinaryActionEntity[] }) {}
}

export class UpdateFinalDisciplinaryAction implements Action {
  public readonly type = FinalDisciplinaryActionActionTypes.UpdateFinalDisciplinaryAction;

  constructor(public payload: { finalDisciplinaryAction: Update<FinalDisciplinaryActionEntity> }) {}
}

export class UpdateFinalDisciplinaryActions implements Action {
  public readonly type = FinalDisciplinaryActionActionTypes.UpdateFinalDisciplinaryActions;

  constructor(
    public payload: { finalDisciplinaryActions: Update<FinalDisciplinaryActionEntity>[] },
  ) {}
}

export class DeleteFinalDisciplinaryAction implements Action {
  public readonly type = FinalDisciplinaryActionActionTypes.DeleteFinalDisciplinaryAction;

  constructor(public payload: { id: string }) {}
}

export class DeleteFinalDisciplinaryActions implements Action {
  public readonly type = FinalDisciplinaryActionActionTypes.DeleteFinalDisciplinaryActions;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearFinalDisciplinaryActions implements Action {
  public readonly type = FinalDisciplinaryActionActionTypes.ClearFinalDisciplinaryActions;
}

export type FinalDisciplinaryActionActions =
  | LoadFinalDisciplinaryActions
  | AddFinalDisciplinaryAction
  | UpsertFinalDisciplinaryAction
  | AddFinalDisciplinaryActions
  | UpsertFinalDisciplinaryActions
  | UpdateFinalDisciplinaryAction
  | UpdateFinalDisciplinaryActions
  | DeleteFinalDisciplinaryAction
  | DeleteFinalDisciplinaryActions
  | ClearFinalDisciplinaryActions;
